import React from 'react';
import './price_line.scss';
import { Text, Icon, Tooltip, Modal } from '@ui-kit';
const Qestion = '/images/icons/help-circle-gray400.svg';

const licensesTooltipe = (
  <>
    <Text as="h6" className="hoverbackground__tooltip-title">
      Download for $0
    </Text>
    <Text as="h6" className="hoverbackground__tooltip">
      Unlimited access to the gallery for subscribers forever!
    </Text>
  </>
);

const licensesModal = (
  <>
    <Text as="h6" className="modal__title">
        Download for $0
      </Text>
    <Text as="h6" className="modal__subtitle">
      Unlimited access to the gallery for subscribers forever!
    </Text>
  </>
);

const freeTooltipe = (
  <>
    <Text as="h6" className="hoverbackground__tooltip-title">
      Download for $0
    </Text>
    <Text as="h6" className="hoverbackground__tooltip">
      Illustration may change it's status from <br />
      free to paid. We rotate some of them daily.
    </Text>
  </>
);

const freeModal = (
  <>
    <Text as="h6" className="modal__title">
      Download for $0
    </Text>
    <Text as="h6" className="modal__subtitle">
      Illustration may change it's status from <br />
      free to paid. We rotate some of them daily.
    </Text>
  </>
);

const PriceLine = ({ price, currency, isFree }) => {
  return (
    <div className="price_line mb-20 d-flex ai-center">
      <Text as="h5" className="info__header mr-8">
        Price:
      </Text>
      <Text as="h5" className="info__content mr-8">
        {currency}
        {price}
      </Text>
      <Tooltip
        content={isFree ? freeTooltipe : licensesTooltipe}
        position="left"
        ancorPosition="anchor-right-middle"
      >
        <Icon src={Qestion} className="question__icon" alt="question__icon" />
      </Tooltip>

      <Modal
        content={isFree ? freeModal : licensesModal}
      >
        <Icon src={Qestion} className="question__icon" alt="question__icon" />
      </Modal>
    </div>
  );
};

export default PriceLine;
